function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 110 16A8 8 0 018 0zm.037 3c-.258 0-.487.14-.487.49v.465c-1.484.14-2.43 1.043-2.43 2.336 0 1.13.682 1.88 1.989 2.178l1.163.274c.848.203 1.198.506 1.198 1.019 0 .664-.51 1.083-1.421 1.083-.682 0-1.25-.262-1.765-.827-.293-.297-.453-.361-.67-.361-.35 0-.614.227-.614.617 0 .344.195.7.544 1.008.459.425 1.175.687 1.972.763v.46c0 .35.229.495.493.495.257 0 .487-.146.487-.495v-.466C10.037 11.87 11 10.949 11 9.61c0-1.153-.682-1.852-2.097-2.166l-1.164-.268c-.728-.163-1.083-.501-1.083-.996 0-.594.504-1.025 1.295-1.025.642 0 1.09.221 1.588.786.252.268.447.367.71.367.321 0 .568-.227.568-.565 0-.326-.19-.681-.51-1.002-.424-.407-1.06-.675-1.777-.768v-.484C8.53 3.146 8.3 3 8.037 3z",
    fill: "#212A33",
    fillRule: "evenodd"
  }));
}

export var ReactComponent = SvgComponent;
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/badges/ic-badge-money.svg";